// Helper pour mapper les couleurs aux classes Tailwind complètes
export const colorClassMap = {
  indigo: {
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
    text: 'text-indigo-600',
    gradient: 'from-indigo-600 to-purple-600',
  },
  blue: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-600',
    gradient: 'from-blue-600 to-cyan-600',
  },
  purple: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    text: 'text-purple-600',
    gradient: 'from-purple-600 to-pink-600',
  },
  emerald: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-600',
    gradient: 'from-emerald-600 to-teal-600',
  },
  orange: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-600',
    gradient: 'from-orange-600 to-red-600',
  },
  red: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-600',
    gradient: 'from-red-600 to-rose-600',
  },
  pink: {
    bg: 'bg-pink-50',
    border: 'border-pink-200',
    text: 'text-pink-600',
    gradient: 'from-pink-600 to-rose-600',
  },
} as const;

export function getColorClasses(color: string) {
  return colorClassMap[color as keyof typeof colorClassMap] || colorClassMap.indigo;
}





